import { soFetch } from 'so-fetch';
import * as  constants from './sign-in-constants';

export function sendCredentials(credentials = {}) {
  return dispatch => {
    return fetch('/signin', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    }).then(response => response.json())
    .then(res => {
      if (res.message) throw new Error(res.message);
      return res;
    });
  };
}

export function updateInfoBox(messages) {
  return {
    type: constants.UPDATE_INFO_BOX,
    messages,
  };
}

export function clearInfoBoxMessage() {
  return { type: constants.CLEAR_INFO_BOX_MESSAGE };
}

export function authReceived(authToken) {
  return {
    type: constants.AUTH_RECEIVED,
    payload: {
      authToken,
    },
  };
}

export function forgotPassword(email) {
  return soFetch('/proxy/forgot-password', {
    method: 'put',
    body: { email },
    actionType: constants.FORGOT_PASSWORD,
  });
}

export function sendConfirmationLink(email) {
  return dispatch => {
    return fetch('/proxy/send-confirmation-link', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({email}),
    })
    .then((res) => {
      if (res.status !== 200) throw new Error(res.status);
      else dispatch({type: constants.SEND_CONFIRMATION_LINK})
    });
  };
}


export function confirmSigninEmail(token) {
  return ({ type: 'CONFIRM_SIGNIN_EMAIL', payload: { token } });
}


export function resetPasswordWithToken(newPassword, token) {
  return soFetch('/proxy/reset-password-with-token', {
    method: 'put',
    body: {
      newPassword,
      token,
    },
    actionType: constants.RESET_PASSWORD_WITH_TOKEN,
  });
}

export function sendSecondaryEmailConfirmation(email) {
  return soFetch('/proxy/secondary-email/send-secondary-email-confirmation', {
    method: 'put',
    body: { email, type: 'signin' },
    actionType: constants.SEND_SECONDARY_EMAIL_CONFIRMATION,
  });
}

export function confirmSecondaryEmail(token) {
  return dispatch => {
    return (soFetch('/proxy/secondary-email/confirm-secondary-email', {
      method: 'put',
      body: { token, type: 'signin' },
      actionType: constants.CONFIRM_SECONDARY_EMAIL,
    })(dispatch));
  };
}

export function disassociateSecondaryEmail(email) {
  return soFetch('/proxy/secondary-email/disassociate-secondary-email', {
    method: 'put',
    body: { email, type: 'signin' },
    actionType: constants.DISASSOCIATE_SECONDARY_EMAIL,
  });
}

export function confirmDisassociateSecondary(id) {
  return dispatch => {
    return (soFetch('/proxy/secondary-email/confirmed-disassociate-secondary-email', {
      method: 'put',
      body: { id, type: 'signin' },
      actionType: constants.CONFIRM_DISASSOCIATE_SECONDARY,
    })(dispatch));
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/sign-in/sign-in-actions.js